import { getApiUrl } from '../config/api';

export const LANDMARK_META = {
  hospital: { label: 'Hospital', emoji: '🏥', color: '#d32f2f' },
  metro: { label: 'Metro', emoji: '🚇', color: '#1565c0' },
  airport: { label: 'Airport', emoji: '✈️', color: '#6a1b9a' },
  railway: { label: 'Railway', emoji: '🚆', color: '#e65100' },
  tourist: { label: 'Attraction', emoji: '📍', color: '#2e7d32' },
  event: { label: 'Event venue', emoji: '🎭', color: '#c2185b' },
  property: { label: 'Your stay', emoji: '🏨', color: '#003580' },
};

export const MAP_FIRST_USP =
  "Book smarter by seeing exactly where you'll stay and what's around you.";

export const fetchNearbyLandmarks = async ({ lat, lng, city, radius = 8000 }) => {
  if (lat == null || lng == null) {
    if (!city) return [];
    try {
      const res = await fetch(
        getApiUrl(`/api/geocode/nearby-landmarks?city=${encodeURIComponent(city)}&radius=${radius}`)
      );
      const data = await res.json();
      return data.success ? data.landmarks || [] : [];
    } catch {
      return [];
    }
  }

  try {
    const res = await fetch(
      getApiUrl(`/api/geocode/nearby-landmarks?lat=${lat}&lng=${lng}&radius=${radius}`)
    );
    const data = await res.json();
    return data.success ? data.landmarks || [] : [];
  } catch {
    return [];
  }
};

export const landmarksFromProperty = (property) => {
  if (!property) return [];
  const items = [];

  (property.touristPlaces || []).forEach((place, idx) => {
    if (!place?.name) return;
    items.push({
      id: `prop-tourist-${idx}`,
      type: 'tourist',
      name: place.name,
      lat: null,
      lng: null,
      distance: place.distance,
      source: 'property',
    });
  });

  (property.nearbyPlaces || []).forEach((place, idx) => {
    if (!place?.name) return;
    const cat = String(place.category || '').toLowerCase();
    let type = 'tourist';
    if (cat.includes('hospital')) type = 'hospital';
    else if (cat.includes('metro') || cat.includes('subway')) type = 'metro';
    else if (cat.includes('airport')) type = 'airport';
    else if (cat.includes('rail') || cat.includes('train') || cat.includes('bus')) type = 'railway';
    else if (cat.includes('stadium') || cat.includes('event') || cat.includes('hall')) type = 'event';

    items.push({
      id: `prop-nearby-${idx}`,
      type,
      name: place.name,
      lat: null,
      lng: null,
      distance: place.distance,
      source: 'property',
    });
  });

  return items;
};
